import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales: ['es-MX', 'es-CO', 'es-CR'],
  defaultLocale: 'es-MX',
  localeDetection: true
})

export type Locale = (typeof routing.locales)[number]

export type Language = 'es'

export enum Country {
  MX = 'MX',
  CO = 'CO',
  CR = 'CR'
}

export const countryToLocalesMap: Record<Country, Locale[]> = {
  MX: ['es-MX'],
  CO: ['es-CO'],
  CR: ['es-CR']
} as const
